import { Link, Typography } from '@material-ui/core';

interface NotificationSettingContactsUpdatePhoneDesktopProps {
  type: 'carrier' | 'dispatcher';
}

export function NotificationSettingContactsUpdatePhoneDesktop({
  type,
}: NotificationSettingContactsUpdatePhoneDesktopProps) {
  return (
    <Typography color="textSecondary">
      Update at{' '}
      {type === 'carrier' ? (
        <Link
          color="primary"
          rel="noreferrer"
          target="_blank"
          // eslint-disable-next-line no-restricted-syntax
          href="/tms/profile/carrier_info"
        >
          Carrier Profile
        </Link>
      ) : (
        <Link
          color="primary"
          rel="noreferrer"
          target="_blank"
          // eslint-disable-next-line no-restricted-syntax
          href="/tms/users"
        >
          Dispatcher Profile
        </Link>
      )}
    </Typography>
  );
}
